import React from "react";
import { at } from "lodash";
import { useField } from "formik";
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from "@material-ui/core";

export default function MCheckBox(props) {
    const { label, labelPlacement, ...rest } = props;
    const [field, meta, helper] = useField(props);
    const { setValue } = helper;

    function _renderHelperText() {
        const [touched, error] = at(meta, "touched", "error");
        if (touched && error) {
            return <FormHelperText>{error}</FormHelperText>;
        }
    }

    function _onChange(e) {
        setValue(e.target.checked);
    }

    return (
        <FormControl {...rest}>
            <FormControlLabel
                // value={field.checked}
                // checked={field.value}
                control={
                    <Checkbox
                        {...field}
                        checked={field.value}
                        onChange={_onChange}
                        color="primary"
                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />
            {_renderHelperText()}
        </FormControl>
    );
}

MCheckBox.defaultProps = {
    labelPlacement: "end"
};
